import { render } from "./ListCampaigns.vue?vue&type=template&id=90abf024&scoped=true"
import script from "./ListCampaigns.vue?vue&type=script&lang=js"
export * from "./ListCampaigns.vue?vue&type=script&lang=js"

import "./ListCampaigns.vue?vue&type=style&index=0&id=90abf024&lang=scss"
import "./ListCampaigns.vue?vue&type=style&index=1&id=90abf024&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90abf024"]])

export default __exports__